import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import OEStdModalController from '../../modals/oe-std-modal-controller';
import {OEButtonControl} from '../../elements/controls/oe-controls';
import {OEBlurModalBackdropLayer} from '../oe-blur-layer';

export class OEFreePremiumViewTest extends React.PureComponent {

    constructor(props) {
        super(props);

        this.options = this.props.options;

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            options: this.props.options,
            strings: {
                closeBtn: 'Close'
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onRef = this.onRef.bind(this);

        this.onOptionsChanged = this.onOptionsChanged.bind(this);

        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            closeBtn: si.getLocalizedStringEnc('disclaimer_close')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
    }

    render() {
        let featureString = this.state.options && typeof(this.state.options.feature) === 'number' ? 'Feature - ' + this.state.options.feature.toString() : '';

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEStdModalController 
                    moduleId={this.props.moduleId}
                    className="clear-backdrop center fit-content disclaimer-view"
                    noHeader={true}
                    isOpen={this.props.isOpen}
                    hasCloseBtn={false}
                    onOpenStateChanged={this.props.onOpenStateChanged}
                    onOptionsChanged={this.onOptionsChanged}
                    onToggle={this.props.onToggle}
                    ref={this.onRef}
                >

                    {!featureString ? null :
                        <div className="options text-dark">
                            {featureString}
                        </div>
                    }

                    <div className="bottom">
                        <OEButtonControl className="close-btn" onPressed={this.onCloseBtnPressed}>{this.state.strings.closeBtn}</OEButtonControl>
                    </div>

                    <OEBlurModalBackdropLayer/>

                </OEStdModalController>
            </React.Fragment>
        );
    }

    onOptionsChanged(sender, options)  {
        this.options = options;
        this.setState({options: this.options});
    }

    onCloseBtnPressed() {
        if(this.ref)    this.ref.setOpen(false);
    }
}

OEFreePremiumViewTest.defaultProps = {
    moduleId: '',
    config: OEDefaultConfigFactory.freePremiumView()
};

OEFreePremiumViewTest.propTypes = {
    moduleId: PropTypes.string,
    config: OEDefaultConfigFactory.freePremiumViewDecl,
    isOpen: PropTypes.bool,
    options: PropTypes.shape({
        feature: PropTypes.number
    }),
    onOpenStateChanged: PropTypes.func,
    onToggle: PropTypes.func,
    fref: PropTypes.func
};

export default frefFromRef(OEFreePremiumViewTest);